<template>
  <div>
    <h4>Sound</h4>
    <div v-if="activeSound" class="my-3">
      <div class="fields-wrapper is-divider">
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label for="animation_selector" class="col-sm-3 col-form-label">
                Sound Selector
              </label>
              <div class="col-sm-9">
                <select
                  id="animation_selector"
                  v-model="activeSound.objectDbHash"
                  class="custom-select"
                  @change="changeSelectedModel($event)"
                >
                  <option
                    v-for="(soundSelector, key) in getSounds"
                    :key="key"
                    class="custom-select"
                    :value="key"
                  >
                    {{ soundSelector.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Sound Type </label>
              <div class="col-sm-9">
                <select
                  placeholder="Select Sound Type"
                  class="custom-select"
                  v-model="activeSound.soundType"
                >
                  <option value="2D">2D</option>
                  <option value="3D">3D</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-3 col-form-label">
                Start Time
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="start_time"
                  @change="mediaStartChanged"
                  v-model="activeSound.startTime"
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                End Time
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="end_time"
                  v-model="activeSound.endTime"
                  readonly
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Duration </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  v-model="activeSound.mediaLength"
                  class="form-control"
                  id="sound_duration_e"
                  readonly
                  :class="{'border-danger': (parseFloat(activeSound.endTime) - parseFloat(activeSound.startTime)).toFixed(2) <= 0}"
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Spatial blend</label>
              <div class="col-sm-9">
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.5"
                  v-model="activeSound.spatialBlend"
                />
                <span class="ml-2">{{ activeSound.spatialBlend }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Audio Options </label>
              <div class="col-sm-9">
                <div class="row align-items-center m-0">
                  <div class="col-3"></div>
                  <div class="col-3">
                    <template v-if="!isAudioPlaying">
                      <button
                        @click="playCurrentSound"
                        class="btn btn-outline-success"
                        id="select_audio_duration_s"
                      >
                        <i class="fa fa-play"></i>
                      </button>
                    </template>
                    <template v-if="isAudioPlaying">
                      <button
                        @click="pauseSound"
                        class="btn btn-outline-warning"
                        id="select_audio_duration_pause"
                      >
                        <i class="fa fa-pause"></i>
                      </button>
                    </template>
                  </div>
                  <div class="col-3">
                    <button
                      @click="stopSound"
                      class="btn btn-outline-danger"
                      id="select_audio_duration_stop"
                    >
                      <i class="fa fa-stop"></i>
                    </button>
                  </div>
                  <div class="col-3"></div>
                </div>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Number of Loops </label>
              <div class="col-sm-9">
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.5"
                  v-model="activeSound.loopCount"
                />
                <span class="ml-2">{{ activeSound.loopCount }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Volume </label>
              <div class="col-sm-9">
                <input
                  type="range"
                  @change="updateVolume"
                  min="0"
                  max="10"
                  step="0.5"
                  v-model="activeSound.volume"
                />
                <span class="ml-2">{{ activeSound.volume }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label"> Pitch </label>
              <div class="col-sm-9">
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.5"
                  v-model="activeSound.pitch"
                />
                <span class="ml-2">{{ pitch }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                Minimum Distance
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="end_time"
                  v-model="activeSound.minimumDistance"
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                Maximum Distance
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="end_time"
                  v-model="activeSound.maximumDistance"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Howl } from "howler";
import $ from "jquery";
import { db } from "../../../../../firebaseDB";
import { uuid } from "vue-uuid";

export default {
  components: {},
  data() {
    return {
      currentLoop: 0,
      currentSelectedSound: "",
      currentSelectedSoundNode: "",
      howl: "",
      sampleSound: null,
      activeModel: "Select Sound",
      end_duration: 0,
      soundType: "2D",
      startTime: 0,
      endTime: 0,
      isAudioPlaying: false,
      isAudioComplete: true,
      numberOfLoops: 1,
      volume: 0.5,
      pitch: 1,
      originalDuration: 0,
      audioMainList: [],
      id: uuid.v1(),
      activeSound: null,
      end_duration: 0
    };
  },
  created() {
    this.listSounds();
    this.getActiveSound();
  },
  methods: {
    ...mapActions(["listSounds"]),
    updateVolume() {
      if (this.sampleSound) {
        this.sampleSound.volume([this.activeSound.volume / 10]);
      }
    },
    onEndEvent() {
      this.currentLoop += 1;
      if (this.currentLoop < this.numberOfLoops) {
        this.playSound(true);
      } else {
        this.currentLoop = 0;
        this.isAudioPlaying = false;
      }
    },
    onLoadEvent() {
      this.activeSound.duration = this.sampleSound.duration(0).toFixed(2);
      this.activeSound.mediaLength = this.sampleSound.duration(0).toFixed(2);
      this.activeSound.endTime = (parseFloat(this.activeSound.startTime) + this.sampleSound.duration(0)).toFixed(2);
    },
    changeSelectedModel (event = null) {
      if (event) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === this.activeSound.objectId
            ? {
              ...char,
              objectDbHash: event.target.value,
              objectName: this.getSounds[event.target.value].name,
              mediaLength: 0,
              audioType: this.getSounds[event.target.value].audioType || 'MPEG',
              endTime: this.activeSound.startTime + 0,
              soundType: this.getSounds[event.target.value].soundType || this.activeSound.soundType,
              audioUrl: this.getSounds[event.target.value].audio.audioURL,
              pitch: this.getSounds[event.target.value].pitch || 0,
              spatialBlend: this.getSounds[event.target.value].spatialBlend || '',
              minimumDistance: this.getSounds[event.target.value].minimumDistance || 0,
              maximumDistance: this.getSounds[event.target.value].maximumDistance || 0,
              duration: 0
            }
            : { ...char }
        )
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    },
    updatedSelectedSound(value) {
      this.end_duration = null;
      this.currentSelectedSound = value;
      this.isAudioPlaying = false;
      this.id = uuid.v1();
      this.soundType = "2D";
      this.volume = 0.5;
      this.numberOfLoops = 1;

      this.currentSelectedSoundNode = this.id;
      this.playSound(false, false);
    },
    playSound(playSound = true, saveToDb = true) {
      if (this.isAudioComplete) {
        if (this.sampleSound) {
          this.sampleSound.stop();
        }
        this.sampleSound = new Howl({
          src: [this.getSounds[this.activeSound.mediaDbHash].audio.audioURL],
          format: ["mp3"],
          volume: this.volume,
          onend: function () {
            this.onEndEvent();
          }.bind(this),
          onload: function () {
            this.onLoadEvent(saveToDb);
          }.bind(this),
        });
        // if (this.soundType === '3D') {
        //   let x = Math.round(100 * (2.5 - (Math.random() * 5))) / 100
        //   let y = Math.round(100 * (2.5 - (Math.random() * 5))) / 100
        //   this.howl.pos(x + 0.5, y + 0.5, -0.5)
        //   this.howl.pannerAttr({
        //     panningModel: 'HRTF',
        //     refDistance: 0.8,
        //     rolloffFactor: 2.5,
        //     maxDistance: 10000,
        //     distanceModel: 'exponential'
        //   })
        // }
      }
      this.closeModal();
    },
    playCurrentSound() {
      if (this.sampleSound) {
        this.sampleSound.stop();
      }
      this.sampleSound = new Howl({
        src: [this.getSounds[this.activeSound.objectDbHash].audio.audioURL],
        format: ["mp3"],
        volume: this.activeSound.volume || 0.5,
        onend: function () {
          this.sampleSound = null;
        }.bind(this),
      });
      this.sampleSound.play();
      this.isAudioPlaying = true;
      this.isAudioComplete = false;
    },
    stopSound() {
      this.isAudioPlaying = false;
      this.isAudioComplete = true;
      this.sampleSound.stop();
    },
    pauseSound() {
      this.isAudioPlaying = false;
      this.sampleSound.pause();
    },
    mediaStartChanged() {
      this.activeSound.endTime = (parseFloat(this.activeSound.endTime) + parseFloat(this.activeSound.duration)).toFixed(2)
    },
    saveToDB() {
      let tRef = db.ref().child("stories/" + localStorage.getItem("storyId"));
      tRef.once("value").then(async (snapshot) => {
        let json = snapshot.val().json;
        let updates = {};
        let keyExist = null;
        let mediaExist = false;
        if (json["mediaList"] && json["mediaList"]["media2d"]) {
          mediaExist = true;
          const soundInfo = json["mediaList"]["media2d"];
          for (const key in soundInfo) {
            if (
              soundInfo[key]["mediaType"] === "SoundFile" &&
              soundInfo[key]["mediaId"] === this.currentSelectedSoundNode
            ) {
              this.id = this.currentSelectedSoundNode;
              keyExist = key;
              break;
            }
          }
        }
        let finalData = {
          mediaId: this.id,
          mediaName: this.getSounds[this.currentSelectedSound]["name"],
          mediaType: "SoundFile",
          mediaDescription:
            this.getSounds[this.currentSelectedSound]["description"],
          mediaDbHash: this.currentSelectedSound,
          mediaLength: this.originalDuration,
          mediaStart: this.startTime,
          mediaEnd: this.endTime,
          mediaVolume: this.volume,
          mediaLoops: this.numberOfLoops,
          soundType: this.soundType,
          mediaUrl:
            this.getSounds[this.currentSelectedSound]["audio"]["audioURL"],
        };
        if (keyExist !== null) {
          json["mediaList"]["media2d"][keyExist] = finalData;
        } else {
          if (!mediaExist) {
            json["mediaList"] = {};
            json["mediaList"]["elementType"] = "media2d";
            json["mediaList"]["media2d"] = [];
          }
          json["mediaList"]["media2d"].push(finalData);
        }
        updates[localStorage.getItem("storyId") + `/json`] = json;
        db.ref("stories")
          .update(updates)
          .then(() => {
            this.showSuccessToast();
          })
          .catch((e) => {
            this.showErrorToast();
          });
      });
    },
    showSuccessToast() {
      this.$toast("Sound inspector data saved", {
        timeout: 3000,
        type: "success",
        showCloseButtonOnHover: true,
      });
    },
    showErrorToast() {
      this.$toast("Sound inspector data failed", {
        timeout: 3000,
        type: "error",
        showCloseButtonOnHover: true,
      });
    },
    showAddNewSoundModal: function () {
      this.$nextTick(() => {
        $("#character-modal").modal("show");
      });
    },
    closeModal() {
      this.$nextTick(() => {
        $("#character-modal").modal("hide");
        if (this.sampleSound) {
          this.sampleSound.stop();
        }
      });
    },
    playSelectedSound(sound) {
      if (this.sampleSound) {
        this.sampleSound.stop();
      }
      this.sampleSound = new Howl({
        src: [sound.audio.audioURL],
        format: ["mp3"],
        volume: 0.5,
        onend: function () {
          this.sampleSound = null;
        }.bind(this),
      });
      this.sampleSound.play();
    },
    stopSelectedSound() {
      this.sampleSound.stop();
    },
    getActiveSound() {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeSound = char
          if (!char.duration) {
            if(this.sampleSound) {
              this.sampleSound.stop()
            }
          this.sampleSound = new Howl({
            src: [char.audioUrl],
            format: ['mp3'],
            onload: function () {
              this.onLoadEvent()
            }.bind(this)
            })
          }
          found = true
        }
      }
      if (!found) {
        this.activeSound = this.characters[0]
      }
    }
  },
  watch: {
    startTime: function (value) {
      if (value) {
        this.endTime = parseFloat(value) + this.end_duration;
      } else {
        this.endTime = this.end_duration;
      }
      // this.saveToDB()
    },
    end_duration: function (value) {
      this.endTime = parseFloat(value) + parseFloat(this.startTime);
    },
    numberOfLoops: function (val) {
      this.end_duration = parseFloat(this.originalDuration) * parseFloat(val);
      // this.saveToDB()
    },
    currentSelectedSound: function () {
      this.end_duration = 0;
      this.endTime = 0;
      this.isAudioPlaying = false;
      this.isAudioComplete = true;
      this.playSound(false);
    },
    characters (val) {
      this.isLoaded = false
      this.getActiveSound()
    },
  },
  computed: {
    ...mapGetters(["getSounds"]),
    ...mapState(['characters']),
  },
};
</script>
<style>
.selectSound {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/media-sounds/maininspector.vue